import './index.styl';
import template from './index.jst';
import TeamControls from '../../Controls';
import Radio from 'backbone.radio';

const CHANNEL_TRADE = Radio.channel('trade');

/**
 * @description View for trade and team info.
 */
export class TradeInfoBar extends TeamControls {
	get className() {
		return 'team-builder-controls trade-info-bar';
	}

	get template(){
		return template;
	}

	initListeners(){
		this.listenTo(this.model, 'change', this.render);
		this.listenTo(CHANNEL_TRADE, 'data:changed', this.init);
		this.listenTo(CHANNEL_TRADE, 'trade:team:value:update', this.onTeamValueUpdate);

		return this;
	}

	onTeamValueUpdate(args){
		this.model.set(args);
	}
}

export default TradeInfoBar;